const trustPoints = [
  { icon: 'ri-file-shield-2-line', text: 'Sin contratos forzosos' },
  { icon: 'ri-smartphone-line', text: 'Registro digital' },
  { icon: 'ri-price-tag-3-line', text: 'Planes desde $289/mes' },
  { icon: 'ri-customer-service-2-line', text: 'Orientacion para solicitar servicios' },
];

function scrollToFinalCta() {
  const el = document.getElementById('cta-final');
  if (el) el.scrollIntoView({ behavior: 'smooth', block: 'start' });
}

export default function Hero() {
  return (
    <section id="hero" className="relative overflow-hidden bg-[#FBFAFF] pt-24 md:pt-28">
      <div className="absolute left-1/2 top-0 h-[520px] w-[520px] -translate-x-1/2 rounded-full bg-[#E9E5FF] blur-3xl" />
      <div className="relative mx-auto grid max-w-7xl gap-10 px-4 pb-16 md:grid-cols-[1.05fr_0.95fr] md:px-6 md:pb-24">
        <div className="flex flex-col justify-center">
          <span className="mb-5 inline-flex w-fit items-center gap-2 rounded-full border border-[#DDD8F5] bg-white px-4 py-2 text-xs font-black uppercase tracking-wide text-[#534AB7]">
            <i className="ri-shield-star-fill" />
            Membresia de prevision funeraria
          </span>

          <h1 className="font-title max-w-3xl text-[2.55rem] font-black leading-[1.04] tracking-[-0.045em] text-[#171421] sm:text-5xl lg:text-[4.55rem]">
            Organiza hoy una membresia funeraria clara desde{' '}
            <span className="text-[#534AB7]">$289 al mes</span>
          </h1>

          <p className="mt-6 max-w-2xl text-base leading-8 text-[#625D70] md:text-lg">
            Coverly ayuda a dejar ordenada una parte sensible de la vida familiar, con una membresia mensual para registrar al titular y familiares dentro del plan contratado.
          </p>

          <p className="mt-4 max-w-xl rounded-2xl border border-[#E6E2F8] bg-white px-4 py-3 text-sm font-bold text-[#3F3958]">
            No se trata de pensar en lo peor. Se trata de dejar instrucciones claras para tu familia.
          </p>

          <div className="mt-7 flex flex-col gap-3 sm:flex-row">
            <button
              onClick={scrollToFinalCta}
              className="inline-flex min-h-[54px] items-center justify-center gap-2 rounded-full bg-[#534AB7] px-8 py-4 text-base font-black text-white shadow-xl shadow-[#534AB7]/20 transition-transform hover:scale-[1.02]"
            >
              Crear mi membresia
              <i className="ri-arrow-right-line text-lg" />
            </button>
            <a
              href="https://wa.me/526675680042?text=Hola%2C%20quiero%20informacion%20sobre%20Coverly"
              target="_blank"
              rel="noopener noreferrer"
              className="inline-flex min-h-[54px] items-center justify-center gap-2 rounded-full border border-[#DDD8F5] bg-white px-8 py-4 text-base font-black text-[#534AB7] transition-colors hover:bg-[#F2F0FF]"
            >
              <i className="ri-whatsapp-line text-lg" />
              Hablar con un asesor
            </a>
          </div>

          <div className="mt-8 flex flex-wrap gap-3">
            {trustPoints.map((item) => (
              <div key={item.text} className="inline-flex items-center gap-2 rounded-2xl border border-[#ECE9FA] bg-white px-3 py-2 text-xs font-bold text-[#5F596D]">
                <i className={`${item.icon} text-[#534AB7]`} />
                {item.text}
              </div>
            ))}
          </div>
        </div>

        <div className="relative flex items-center justify-center md:justify-end">
          <div className="absolute right-0 top-8 h-72 w-72 rounded-full bg-[#534AB7]/15 blur-3xl" />
          <div className="relative w-full max-w-[430px] rounded-[34px] border border-[#DDD8F5] bg-white p-4 shadow-2xl shadow-[#3C3489]/15">
            <div className="rounded-[28px] bg-gradient-to-br from-[#5B51C9] to-[#2A235F] p-5 text-white">
              <div className="flex items-start justify-between">
                <div>
                  <p className="text-xs font-black uppercase tracking-[0.2em] text-white/55">Coverly</p>
                  <h2 className="mt-1 text-xl font-black">Membresia Activa</h2>
                </div>
                <span className="rounded-full bg-emerald-400/15 px-3 py-1 text-xs font-black text-emerald-200">Activa</span>
              </div>

              <div className="mt-7 rounded-3xl bg-white/10 p-4">
                <p className="text-sm text-white/60">Tu plan</p>
                <div className="mt-2 flex items-end justify-between">
                  <p className="text-3xl font-black">$289</p>
                  <p className="pb-1 text-sm font-bold text-white/65">/mes</p>
                </div>
                <p className="mt-2 text-sm font-bold text-white/80">Titular + 2 familiares registrados</p>
              </div>

              <div className="mt-5 rounded-3xl bg-white p-4 text-[#252138]">
                <p className="text-xs font-black uppercase tracking-wide text-[#827B96]">Personas registradas</p>
                {['Titular', 'Familiar 1', 'Familiar 2'].map((name) => (
                  <div key={name} className="mt-3 flex items-center justify-between rounded-2xl bg-[#F7F6FF] px-3 py-2">
                    <div className="flex items-center gap-2">
                      <span className="flex h-8 w-8 items-center justify-center rounded-full bg-[#EDEAFF] text-[#534AB7]">
                        <i className="ri-user-line" />
                      </span>
                      <span className="text-sm font-black">{name}</span>
                    </div>
                    <span className="text-xs font-black text-emerald-600">Activo</span>
                  </div>
                ))}
              </div>
            </div>

            <div className="mt-4 grid grid-cols-2 gap-3">
              <div className="rounded-3xl bg-[#F4F2FF] p-4">
                <p className="text-xs font-black uppercase text-[#827B96]">Pagos</p>
                <p className="mt-1 text-lg font-black text-[#262139]">Al corriente</p>
              </div>
              <div className="rounded-3xl bg-[#F4F2FF] p-4">
                <p className="text-xs font-black uppercase text-[#827B96]">Prime</p>
                <p className="mt-1 text-lg font-black text-[#262139]">$399/mes</p>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}
